import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=f668d72e&scoped=true&"
import script from "./friends.vue?vue&type=script&lang=js&"
export * from "./friends.vue?vue&type=script&lang=js&"
import style0 from "./friends.vue?vue&type=style&index=0&id=f668d72e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f668d72e",
  null
  
)

export default component.exports